import { RootState } from 'store/store';

export const selectNotifications = (state: RootState) => state.notifications.items;
export const selectNotificationsLoading = (state: RootState) => state.notifications.loading;
export const selectNotificationsError = (state: RootState) => state.notifications.error;
export const selectNotificationsFilters = (state: RootState) => state.notifications.filters;
export const selectNotificationsTotal = (state: RootState) => state.notifications.total;
export const selectNotificationsPageSize = (state: RootState) => state.notifications.pageSize;
export const selectCurrentNotification = (state: RootState) => state.notifications.currentNotification;
export const selectHasMoreNotifications = (state: RootState) => state.notifications.hasMore;

// Unified read-state selectors
export const selectGlobalLastReadId = (state: RootState) => state.notifications.globalLastReadId;
export const selectPageLastReadId = (state: RootState) => state.notifications.pageLastReadId;
